import { reduxForm, change, reset } from 'redux-form'
import { Autosuggest } from '../../components/common'
import { getAvailableOrgs } from '../../actions/typeaheads'
import { resetRefundExamFlow } from '../../actions/refundExam'
import {
  ORG_SEARCH_FORM_NAME,
  ORG_SEARCH_FIELD_NAME,
  ORG_SEARCH_FIELD_ID,
  STUDENT_SEARCH_FORM_NAME,
  EXAM_SEARCH_FORM_NAME,
} from '../../constants/RefundExamConstants'

const checkSchoolSelected = (val, allValues) =>
  Boolean(allValues[ORG_SEARCH_FIELD_ID])
    ? undefined
    : 'Error: You must select a school from the dropdown.'

const RefundOrgSearchForm = ({ change, reset, resetRefundExamFlow }) => (
  <form onSubmit={e => e.preventDefault()}>
    <label htmlFor={ORG_SEARCH_FIELD_NAME}>
      Search for the school where student is taking the exam.
    </label>
    <Autosuggest
      formGroupStyles={{ marginBottom: 0 }}
      placeholder="Start typing to search for organization"
      isRequired={true}
      name={ORG_SEARCH_FIELD_NAME}
      fetchSuggestions={val => getAvailableOrgs(val, { searchWithinAP: true })}
      renderSuggestion={s => (
        <div>
          <div>{s.orgName}</div>
          <div>{s.address}</div>
        </div>
      )}
      onChangeAction={() => change(ORG_SEARCH_FIELD_ID, null)}
      selectSuggestion={async val => {
        await resetRefundExamFlow()
        await reset(STUDENT_SEARCH_FORM_NAME)
        await reset(EXAM_SEARCH_FORM_NAME)
        change(ORG_SEARCH_FIELD_NAME, val.orgName)
        change(ORG_SEARCH_FIELD_ID, val.orgId)
      }}
      validate={[checkSchoolSelected]}
    />
  </form>
)

export default connect(
  null,
  { change, reset, resetRefundExamFlow }
)(
  reduxForm({
    form: ORG_SEARCH_FORM_NAME,
    initialValues: {
      [ORG_SEARCH_FIELD_NAME]: null,
      [ORG_SEARCH_FIELD_ID]: null,
    },
  })(RefundOrgSearchForm)
)
